/** Como a comissão da revenda é calculada sobre a mensalidade do posto. */
export enum CommissioningType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage',
}

export const commissioningTypeChoices = [
  { id: CommissioningType.FIXED, name: 'Fixada' },
  { id: CommissioningType.PERCENTAGE, name: 'Porcentagem' },
];
